const bookToChapterAndVerseCounts = require('./book_to_chapter_and_verse_counts.json')

var bookToVerseCount = {}
Object.keys(bookToChapterAndVerseCounts).forEach((book) => {
  bookToVerseCount[book] = 0
  bookToChapterAndVerseCounts[book].forEach((chapter) => {
    bookToVerseCount[book] += chapter['verses']
  })
})
var chapterKeyToVerseCount = {}
Object.keys(bookToChapterAndVerseCounts).forEach((book) => {
  bookToChapterAndVerseCounts[book].forEach((chapter) => {
    chapterKeyToVerseCount[book + '/Chapter ' + chapter['chapter']] = chapter['verses']
  })
})

export function versesInKey (key) {
  const keyParts = key.split('/')
  if (!(/\d$/.test(key))) {
    return bookToVerseCount[keyParts[keyParts.length - 1]]
  } else {
    return chapterKeyToVerseCount[keyParts.slice(keyParts.length - 2).join('/')]
  }
}



// WEBPACK FOOTER //
// ./src/mixins/book_to_chapter_and_verse_counts.js